var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-header"},[_vm._m(0),(_vm.latest)?_c('div',{staticClass:"dev-header-right"},[_c('DownloadButton',{attrs:{"download":_vm.latest}})],1):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-header-left"},[_c('p',{staticClass:"dev-header-title third-font",attrs:{"dcolor":""}},[_vm._v("My Space 1A")])])
}]

export { render, staticRenderFns }